//***********************************************************************************
// TMS WEB CORE framework code is copyright (c) 2018 - 2020 by tmssoftware.com bvba
// The code or parts of the code cannot be used in any way outside 
// a TMS WEB Core application generated by a licensed user or company.
//***********************************************************************************
